import { useCallback, useEffect, useState } from "react";
import { ExternalLink, FileText, X } from "lucide-react";
import { useParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useI18n } from "../lib/i18n";

export default function CareTrainingPlanOriginal() {
  const { planId, reviewId } = useParams();
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const response = await api.get(reviewId
        ? `/care/club-training-plan-reviews/${reviewId}`
        : `/care/training-plans/${planId}`);
      setData(response.data); setError("");
    } catch (requestError) {
      setError(apiError(requestError.response?.data?.detail));
    }
  }, [planId, reviewId]);
  useEffect(() => { load(); }, [load]);

  const close = () => {
    window.close();
    window.setTimeout(() => { if (!window.closed) window.history.back(); }, 50);
  };

  return <main className="min-h-screen p-4 md:p-6" style={{ background: "var(--pc-black)", color: "var(--pc-text)" }} data-testid="training-plan-original-view">
    <header className="max-w-[1500px] mx-auto flex items-center gap-3 pb-4">
      <div className="min-w-0"><p className="text-[11px] uppercase tracking-[.15em]" style={{ color: "var(--pc-cyan)" }}>{t("originalTrainingPlan")}</p><h1 className="text-xl font-display font-bold mt-1">{data ? `${data.player.name} · ${data.training_plan.week_start} · V${data.training_plan.version}` : t("loading")}</h1></div>
      <button type="button" className="pc-btn pc-btn-ghost ml-auto flex items-center gap-2" onClick={close}><X size={15} /> {t("close")}</button>
    </header>
    {error && <div className="max-w-[1500px] mx-auto rounded-xl p-4" style={{ background: "rgba(255,84,112,.1)", color: "var(--pc-score-poor)", border: "1px solid rgba(255,84,112,.28)" }}>{error}</div>}
    {!data && !error && <div className="pc-spinner mx-auto mt-16" />}
    {data && <section className="max-w-[1500px] mx-auto grid gap-4" style={{ gridTemplateColumns: data.training_plan.documents.length > 1 ? "repeat(auto-fit,minmax(min(520px,100%),1fr))" : "minmax(0,1fr)" }}>
      {data.training_plan.documents.map((document) => <article key={document.id} className="pc-card overflow-hidden min-h-[78vh] flex flex-col">
        <div className="px-4 py-3 border-b flex items-center gap-2" style={{ borderColor: "var(--pc-border)" }}><FileText size={15} color="var(--pc-cyan)" /><span className="text-sm font-semibold truncate">{document.filename}</span><a className="ml-auto" href={document.download_path} target="_blank" rel="noreferrer" aria-label={t("openInNewTab")}><ExternalLink size={15} color="var(--pc-cyan)" /></a></div>
        {document.mime_type?.startsWith("image/")
          ? <div className="flex-1 grid place-items-center p-3" style={{ background: "var(--pc-card-inset)" }}><img src={document.download_path} alt={document.filename} className="max-w-full max-h-[calc(100vh-110px)] object-contain" /></div>
          : <object data={document.download_path} type={document.mime_type || "application/pdf"} className="w-full flex-1 min-h-[76vh]" aria-label={document.filename}><a href={document.download_path} target="_blank" rel="noreferrer" className="p-5 flex items-center gap-2" style={{ color: "var(--pc-cyan)" }}>{t("openOriginal")} <ExternalLink size={14} /></a></object>}
      </article>)}
    </section>}
  </main>;
}
